import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { verifyPayment } from "@/lib/api";

export default function ProSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const paymentId = searchParams.get("payment_id") || searchParams.get("collection_id");
    const collectionStatus = searchParams.get("collection_status") || searchParams.get("status");

    if (!paymentId || collectionStatus !== "approved") {
      setStatus("error");
      return;
    }

    verifyPayment(paymentId)
      .then((data) => {
        setStatus(data.success ? "success" : "error");
        if (data.success) setTimeout(() => navigate("/game", { replace: true, state: null }), 3500);
      })
      .catch(() => setStatus("error"));
  }, [searchParams, navigate]);

  if (status === "verifying") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-display text-2xl uppercase animate-pulse">Verificando pago...</div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center space-y-4">
          <div className="font-display text-4xl uppercase">Hmm...</div>
          <p className="font-mono-cm text-sm uppercase tracking-widest text-[#101010]/60">
            No pudimos confirmar tu pago. Si lo realizaste, el acceso PRO se activa en minutos. Si no, intentá de nuevo.
          </p>
          <button
            onClick={() => navigate("/game")}
            className="cm-press border-4 border-[#101010] rounded-xl px-6 py-3 font-display uppercase bg-[#FFDE59] cm-shadow"
          >
            Volver al juego
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="max-w-md w-full bg-[#A8FF76] border-4 border-[#101010] rounded-xl cm-shadow p-8 text-center"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="text-7xl mb-4"
        >
          🎉
        </motion.div>

        <h1 className="font-display text-5xl uppercase mb-2">¡Sos PRO!</h1>
        <p className="font-mono-cm text-sm uppercase tracking-widest text-[#101010]/70 mb-6">
          Debates ilimitados, ranking por categoría y badge visible para todos.
        </p>

        <div className="bg-white border-4 border-[#101010] rounded-xl p-4 mb-6 text-left space-y-2">
          {[
            "Debates ilimitados todos los días",
            "Ranking por categoría desbloqueado",
            "Historial completo de tus debates",
            "Badge PRO + título visible en el ranking",
          ].map((f) => (
            <div key={f} className="flex items-center gap-2 font-mono-cm text-xs uppercase tracking-widest">
              <span className="text-[#101010] font-bold">✓</span>
              <span>{f}</span>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate("/game")}
          className="cm-press w-full bg-[#101010] text-white border-4 border-[#101010] rounded-xl px-6 py-4 font-display uppercase text-xl cm-shadow"
        >
          Jugar ahora →
        </button>

        <p className="font-mono-cm text-[10px] uppercase tracking-widest text-[#101010]/40 mt-3">
          Redirigiendo automáticamente...
        </p>
      </motion.div>
    </div>
  );
}
